import * as React from "react";
import styled, { css } from "styled-components";
import DataLakeOverview from "data-lake/data-lake-overview/DataLakeOverview";
import DataLakeJobs from "data-lake/components/DataLakeJobs";
import DataLakeRetrievableSizeChart from "data-lake/components/DataLakeRetrievableSizeChart";
import DataLakeJournalSection from "data-lake/components/DataLakeJournalSection";
import DataLakeVolumeSection from "data-lake/components/DataLakeVolumeSection";
import DataLakePageNavigation from "data-lake/components/DataLakePageNavigation";
import useDataLakeFSVolumeMetrics from "data-lake/hooks/useDataLakeFSVolumeMetrics";
import useDataLakeBackend from "data-lake/data-lake-backend-config/hooks/useDataLakeBackend";
import useDataLakeConfig from "data-lake/configurations/hooks/useDataLakeConfig";
import { FILESYSTEM_TYPE } from "archive/ArchiveStore";
import { LICENSE_SUBJECTS } from "license/constants";
import LicenseCheck from "license/LicenseCheck";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import useSendTelemetryOnMount from "logic/telemetry/useSendTelemetryOnMount";
import { DATA_LAKE_LICENSE_TITLE, DATA_LAKE_LICENSE_TEXT } from "data-lake/Constants";
import { Alert, Row, Col } from "components/bootstrap";
import { DocumentTitle, PageHeader } from "components/common";
import AppConfig from "util/AppConfig";
import DocsHelper from "util/DocsHelper";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
const Divider = styled.hr(
  ({ theme }) => css`
    margin-top: ${theme.spacings.md};
    margin-bottom: ${theme.spacings.md};
  `
);
const VolumeBorderCol = styled(Col)(
  ({ theme }) => css`
    border-left: 1px solid ${theme.colors.gray[80]};
    padding-left: ${theme.spacings.lg};
  `
);
const DataLakesPage = () => {
  var _a;
  const sendTelemetry = useSendTelemetry("data-lake-overview");
  const { data: dataLakeBackendConfig } = useDataLakeConfig();
  const { data: backend, isSuccess: isBackendLoaded } = useDataLakeBackend(
    dataLakeBackendConfig == null ? void 0 : dataLakeBackendConfig.active_backend,
    !!(dataLakeBackendConfig == null ? void 0 : dataLakeBackendConfig.active_backend)
  );
  const volume = useDataLakeFSVolumeMetrics();
  const isFsBackend = ((_a = backend == null ? void 0 : backend.settings) == null ? void 0 : _a.type) === FILESYSTEM_TYPE;
  const showVolumeSection = isFsBackend && volume.hasData && !volume.isLoading;
  const showJournalSection = !AppConfig.isCloud();
  useSendTelemetryOnMount(
    sendTelemetry,
    TELEMETRY_EVENT_TYPE.DATALAKE.ACTIVE_BACKEND,
    { app_pathname: "data-lake", backend_type: isBackendLoaded && backend ? backend.settings.type : "none" },
    [isBackendLoaded, backend]
  );
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Data Lake Overview" }, /* @__PURE__ */ React.createElement(DataLakePageNavigation, null), /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: "Data Lake Overview",
      documentationLink: {
        title: "Data Lake documentation",
        path: DocsHelper.PAGES.DATA_LAKE
      }
    },
    /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, "Data Lake is a mechanism for storing processed data without ingesting it into OpenSearch.", /* @__PURE__ */ React.createElement("br", null), "The Data Lake Backend can be either an", " ", /* @__PURE__ */ React.createElement("strong", null, "Amazon S3/Google Cloud Storage Bucket/Azure Blob Storage"), ", or local network storage.", /* @__PURE__ */ React.createElement("br", null), "Messages are categorized in Data Lake by Stream. Messages can be retrieved from Data Lake by Stream for a defined time interval.", /* @__PURE__ */ React.createElement("br", null), "Note that storing messages in Data Lake does not count towards license usage, but retrieving messages does.")
  ), /* @__PURE__ */ React.createElement(
    LicenseCheck,
    {
      licenseSubject: LICENSE_SUBJECTS.archive,
      title: DATA_LAKE_LICENSE_TITLE,
      text: DATA_LAKE_LICENSE_TEXT,
      displayWarningContainer: true,
      bsStyle: "danger"
    }
  ), /* @__PURE__ */ React.createElement(DataLakeJobs, null), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(DataLakeRetrievableSizeChart, null), (showJournalSection || showVolumeSection) && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Divider, null), /* @__PURE__ */ React.createElement(Row, null, showJournalSection && /* @__PURE__ */ React.createElement(Col, { md: showVolumeSection ? 6 : 12 }, /* @__PURE__ */ React.createElement(DataLakeJournalSection, null)), showVolumeSection && /* @__PURE__ */ React.createElement(VolumeBorderCol, { md: 6 }, /* @__PURE__ */ React.createElement(DataLakeVolumeSection, { volume })))))), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(DataLakeOverview, null))));
};
export default DataLakesPage;
